import "./svg/breadroll.svg"

export default {
    name: "breadroll",
    viewBox: "103 103",
}
